





















































































































































































































































































import skillbar from '@/components/skillbar.vue';
import SelectSearch from '@/components/select-search.vue';
import { ref, defineComponent, onMounted, computed } from '@vue/composition-api';
import store from '@/store';
// import { bus } from '@/main';
import validation from '@/data/validation.vue';
// import router from '@/router';
import Vue from 'vue';

const bus = new Vue();

const defaultObjInit = () => ({
  skillId: '',
  name: '',
  aka: '',
  description: '',
  parentid: 0,
  skillmasterid: '',
  ratingDescription: 0,
  addToMyPlan: false,
  MyPlan_Relevant: false,
  subSkills: [
    {
      skillId: '',
      name: '',
      aka: '',
      description: '',
      parentid: 0,
      skillmasterid: '',
      ratingDescription: 0,
      addToMyPlan: false,
    },
  ],
});
export default defineComponent({
  name: 'Domain',
  components: { skillbar, SelectSearch, validation },
  setup() {
    const selectedTechnologies = ref([{ ...defaultObjInit() }]);
    const isChangeRole = ref(false);
    const isButtonCheck = ref(false);
    const renderReady = ref(false);
    const apiError = ref(false);
    const loading = ref(false);
    const toggleAccordianVal = ref(1);
    const fetchInitialData = () => {
      store.dispatch('digital/getDigital');
      store.dispatch('profile/getEmployeeProfile');
      store.dispatch('profile/getSkillsProficiency');
      renderReady.value = true;
    };
    onMounted(() => {
      fetchInitialData();
    });
    const skillsDigitalTechnologies = computed(() => store.getters['digital/skillsDigitalTechnologies']);
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    const skillsLevels = computed(() => store.getters['profile/skillsLevels']);
    const proceedButtonState = computed(() => {
      const arr = JSON.parse(JSON.stringify(selectedTechnologies.value));
      /* eslint operator-linebreak: ["error", "after"] */
      if (arr.length === 1 && arr.find((x: any) => x.addToMyPlan) && arr[0].name.toLowerCase() === 'not available') return false;
      return (
        arr.find((x: any) => x.skillId === '') ||
        !(arr.find((x: any) => x.name.toLowerCase() === 'not available') || arr.find((x: any) => (x.addToMyPlan ? x.MyPlan_Relevant : false))) ||
        !!arr.find(
          (x: any) =>
            // eslint-disable-next-line implicit-arrow-linebreak
            !(x.addToMyPlan ? x.name.toLowerCase() === 'not available' : x.name.toLowerCase() === 'not available' || x.name.toLowerCase() === 'not applicable' || x.name.toLowerCase() === 'na') &&
            (!x.skillId || !x.ratingDescription || (x.subSkills.length && !x.subSkills.find((y: any) => y.ratingDescription))),
        )
      );
      // return (
      //   arr.find((x: any) => x.skillId === '') ||
      //   !!arr.find(
      //     (x: any) =>
      //       // eslint-disable-next-line implicit-arrow-linebreak
      //       !(x.addToMyPlan ? x.name.toLowerCase() === 'not available' : x.name.toLowerCase() === 'not available' || x.name.toLowerCase() === 'not applicable' || x.name.toLowerCase() === 'na') &&
      //       (!x.skillId || !x.ratingDescription || (x.subSkills.length && !x.subSkills.find((y: any) => y.ratingDescription))),
      //   )
      // );
    });
    const proceedToNextPage = () => {
      bus.$emit('proceedToNextPage');
    };
    const proceedToNextTab = (path: any) => {
      if (!skillsEmployeeProfile.value.profileComplete && !skillsEmployeeProfile.value.isLegacy && !isChangeRole.value) {
        isButtonCheck.value = true;
        console.log('proceedToNextTab', path);
        bus.$emit('proceedToNextPage', isChangeRole, isButtonCheck);
      } else if (isChangeRole.value) {
        console.log('isChangeRolePath', path);
        // @ts-ignore
        this.$router.push(path);
      }
    };
    const openSkillDefinition = (index: any) => {
      bus.$emit('openSkillDefinition', index);
    };
    const showExtraOptionsModal = (index: any) => {
      bus.$emit('showExtraOptionsModal', index);
    };
    const toggleAccordian = () => {
      toggleAccordianVal.value = 0;
    };
    const toggleAccordianaddvalue = (i: any) => {
      toggleAccordianVal.value = i + 1;
    };
    const showInformationModal = (id: any, options: any) => {
      console.log(id, options);
      // this.infoModalData = { ...options };
      // this.$refs['extra-options-modal-comp'].$data.isOpen = false;
      // this.$refs['proficiency-modal-comp'].$data.isOpen = false;
      // this.$refs['information-modal-comp'].$data.isOpen = true;
      // this.$refs['lang-proficiency-modal-comp'].$data.isOpen = false;
    };
    const inputValueChanged = (val: any, elem: any) => {
      // console.log('val====================', val);
      // console.log('elem-----------------------', elem);
      // const { key } = elem.dataset;
      // const { id } = elem || {};
      const id = elem || {};
      if (id && id.includes('digital-technologies-select-')) {
        const index = parseInt(id.split('digital-technologies-select-')[1], 10);
        const obj = skillsDigitalTechnologies.value.find((x: any) => x.skillId === val.value);
        selectedTechnologies.value[index].skillId = obj.skillId;
        selectedTechnologies.value[index].name = obj.name;
        selectedTechnologies.value[index].ratingDescription = obj.ratingDescription || 0;
        selectedTechnologies.value[index].addToMyPlan = obj.addToMyPlan;
        selectedTechnologies.value[index].MyPlan_Relevant = false;
        selectedTechnologies.value[index].description = obj.Description || '';
        // selectedTechnologies.value[index].ProficiencyLevels = obj.ProficiencyLevels || '';
        // selectedTechnologies.value[index].Link = obj.Link || '';
        // selectedTechnologies.value[index].IdealLevel = obj.IdealLevel || 0;
        selectedTechnologies.value[index].subSkills = JSON.parse(JSON.stringify(obj.subSkills || []));
      }
    };
    const radioBtnClicked = (event: any) => {
      const { target } = event;
      const { id, dataset } = target;
      const { index, subIndex } = dataset;
      console.log('calling');
      // if ((isIE || isEdge) && !isMobileOnly) return;
      if (id && id.includes('sub-technology-service-radio-') && selectedTechnologies.value[index].subSkills[subIndex].ratingDescription) {
        selectedTechnologies.value[index].subSkills[subIndex].ratingDescription = 0;
      } else if (id && id.includes('digital-technologies-radio-') && selectedTechnologies.value[index].ratingDescription && !subIndex) {
        // selectedTechnologies.value[index].Level = 0;
      }
    };
    return {
      skillsDigitalTechnologies,
      selectedTechnologies,
      isChangeRole,
      renderReady,
      apiError,
      loading,
      toggleAccordianVal,
      skillsEmployeeProfile,
      skillsLevels,
      inputValueChanged,
      radioBtnClicked,
      showInformationModal,
      toggleAccordianaddvalue,
      toggleAccordian,
      proceedButtonState,
      proceedToNextPage,
      openSkillDefinition,
      showExtraOptionsModal,
      bus,
      proceedToNextTab,
      isButtonCheck,
    };
  },
});
